import axios from 'axios'
import { Toast } from 'vant';

//创建axios实例
var service = axios.create({
  timeout: 5000,
  headers: {
    'content-type': 'application/json'
  }
})
var baseUrl = process.env.VUE_APP_URL;
// var baseUrl = 'https://www.zhuowendata.com/apis';

console.log('当前环境对象：',process.env);
var Token = 'onlyTest2025';
export default {
  //get请求
  get(url, param, showToast,token) {
    return new Promise((cback, reject) => {
      if(token){
        Token = token;
      }
      service({
        method: 'get',
        url:baseUrl+url,
        headers:{
          'Token':Token
        },
        params: param,
      }).then(res => {
        //axios返回的是一个promise对象 
        let status = res.status.toString();
        let code = res.data.code;
        if (status == 200) {
          cback(res.data);   //cback在promise执行器内部
        } else {
          console.log(res, '异常1')
        }
        if (showToast || code == 500) {
          Toast(res.data.message);
        }
      }).catch(err => {
        if (!err.response) {
          console.log('请求错误');
          Toast('网络不稳定,请稍后再试');
        } else {
          reject(err.response);
          console.log(err.response, '异常2')
        }
      })
    })
  },
  //post请求
  post(url, param, showToast,token) {
    return new Promise((cback, reject) => {
      if(token){
        Token = token;
      }
      service({
        method: 'post',
        url:baseUrl+url,
        headers:{
          'Token':Token
        },
        data: param,
      }).then(res => {
        //axios返回的是一个promise对象 
        let status = res.status.toString();
        let code = res.data.code;
        if (status == 200) {
          cback(res.data);   //cback在promise执行器内部
        } else {
          console.log(res, '异常1')
        }
        if (showToast || code == 500) {
          Toast(res.data.message);
        }
      }).catch(err => {
        if (!err.response) {
          Toast('网络不稳定,请稍后再试');
        } else {
          reject(err.response);
          console.log(err.response, '异常2')
        }
      })
    })
  }
} 


// WEBPACK FOOTER //
// ./src/api/request.js